var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C6.243 10 4 7.757 4 5C4 2.243 6.243 0 9 0C11.757 0 14 2.243 14 5C14 7.757 11.757 10 9 10ZM4.75 12C2.13 12 0 14.13 0 16.75V20.25C0 20.66 0.34 21 0.75 21H10V17.75C10 15.87 11.4 14.32 13.21 14.05C13.47 13.29 13.96 12.65 14.59 12.19C13.59 11.904 13.536 12 4.75 12ZM22.25 16H21V15.25C21 14.285 20.215 13.5 19.25 13.5H16.75C15.785 13.5 15 14.285 15 15.25V16H13.75C13.516 16 13.2845 16.0473 13.0692 16.1388C12.8539 16.2304 12.6593 16.3645 12.497 16.533L18 19.404L23.503 16.533C23.3407 16.3645 23.1461 16.2304 22.9308 16.1388C22.7155 16.0473 22.484 16 22.25 16ZM16.5 16V15.25C16.5 15.1837 16.5263 15.1201 16.5732 15.0732C16.6201 15.0263 16.6837 15 16.75 15H19.25C19.3163 15 19.3799 15.0263 19.4268 15.0732C19.4737 15.1201 19.5 15.1837 19.5 15.25V16H16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.347 20.9148C18.24 20.9706 18.1211 20.9997 18.0005 20.9997C17.8799 20.9997 17.761 20.9706 17.654 20.9148L12 17.9648V22.2498C12 23.2148 12.785 23.9998 13.75 23.9998H22.25C23.215 23.9998 24 23.2148 24 22.2498V17.9648L18.347 20.9148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJob);
export default __webpack_public_path__ + "static/media/ic_job.cecb3b49399d9d575e66baa53411bd2b.svg";
export { ForwardRef as ReactComponent };